import cn from 'classnames';

import Accordion from 'components/accordion/Accordion';
import RichText from 'components/rich-text/RichText';
import Icon from 'components/icon/Icon';
import Proposal from './Proposal';

import { IProposalGroup } from 'source/NFR.types';

interface ProposalGroupProps extends IProposalGroup {
  headingLevel?: 2 | 3 | 4;
}

const ProposalGroup: React.FC<ProposalGroupProps> = ({
  accordion,
  numberOfVisibleItems = 3,
  proposals = [],
  subtitle,
  text,
  title,
  headerAccordion,
  headingLevel
}) => {
  const visibleItems = proposals.slice(0, numberOfVisibleItems);
  const hiddenItems = proposals.slice(numberOfVisibleItems);

  return (
    <div className="proposal-group">
      <Accordion {...headerAccordion} buttonTextForLabel={title}>
        {({ Collapse, Button, isOpen, toggle }) => (
          <div className="proposal-group--header" onClick={toggle}>
            <Button className="proposal-group--header--button">
              {title && <h2>{title}</h2>}
              <Icon
                className={cn('proposal-group--header--icon', {
                  'proposal-group--header--icon--is-open': isOpen
                })}
                name="small-arrow-down"
                fill={true}
              />
            </Button>
            <Collapse>
              <div className="proposal-group--content">
                <p>{subtitle}</p>
                <RichText className="proposal-group--text" {...text} />
              </div>
            </Collapse>
          </div>
        )}
      </Accordion>

      {visibleItems?.map(proposal => (
        <Proposal headingLevel={headingLevel} key={proposal.id} {...proposal} />
      ))}

      <Accordion showButtonText={true} {...accordion}>
        {({ Button: AccordionButton, Collapse }) => (
          <>
            <Collapse>
              <div>
                {hiddenItems?.map(proposal => (
                  <Proposal headingLevel={headingLevel} key={proposal.id} {...proposal} />
                ))}
              </div>
            </Collapse>

            <AccordionButton className="proposal-group--toggle" theme="secondary" />
          </>
        )}
      </Accordion>
    </div>
  );
};

ProposalGroup.displayName = 'ProposalGroup';

export default ProposalGroup;
